import { useEffect, useState } from "react";

import { getProductById, GetProductByIdResponse } from "./ProductsService";

export type ApiCallState<TResponse> = {
    loading: boolean;
    error: Error | null;
    data: TResponse | null;
    refresh?: () => void | undefined;
};

export function useGetProductById(id: number) {
    const [state, setState] = useState<ApiCallState<GetProductByIdResponse>>({
        data: null as any,
        error: null as any,
        loading: false,
    });
    const [refreshIndex, setRefreshIndex] = useState(0);

    useEffect(() => {
        setState({ data: null as any, error: null as any, loading: true });
        (async () => {
            try {
                const data = await getProductById(id);
                setState({ data, error: null, loading: false });
            } catch (error) {
                setState({ data: null, error, loading: false });
            }
        })();
    }, [id, refreshIndex]);

    return {
        ...state,
        refresh: () => setRefreshIndex(refreshIndex + 1),
    };
}
